import React from "react";
import {Link} from "react-router-dom";

const Tech_Research = ({data}) => {
    return (
        <>

            {data.length > 0 ?
                data.map((object) => (


                    <div
                        className="col-xl-4 col-lg-4 wow fadeInUp"
                        data-wow-delay=".3s"
                        style={{
                            visibility: "visible",
                            animationDelay: "0.3s",
                            animationName: "fadeInUp"
                        }}
                    >
                        <div className="blog-two__single">
                            <div className="blog-two__single-img">
                                <div className="inner">
                                    <img src={object.thumbnail} alt=""/>
                                </div>
                                <div className="blog-two__single__meta">
                                    <ul>
                                        <li>
                                            <i className="fa-solid fa-calendar-days"/>{" "}
                                            <Link to="#">June 11, 2024</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="blog-two__single__content">
                                <h4 className="blog-two__single__title">
                                    <Link to="">
                                        {object.name}
                                    </Link>
                                </h4>
                                <Link to="" className="blog-two__single__btn">
                                    Read More <i className="fa fa-plus"/>
                                </Link>
                            </div>
                        </div>
                    </div>))
                :
                <div className="text-danger mx-auto text-center">
                    <span className="fw-bolder">NO AI RESEARCH AVAILABLE</span>
                </div>

            }

        </>
    )
}

export default Tech_Research